import React from 'react';
import { useSelector } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import { colors } from 'style/config';
import anaUtils from 'analytics/utils';
import localeUtils from 'utils/LanguageLocale';
import { productViewsSelector } from 'selectors/page/product/productViews/productViewsSelector';
import { showSessionAIMsgSelector } from 'viewModel/selectors/testTarget/showSessionAIMsgSelector';
import { showSocialProofPDPSelector } from 'viewModel/selectors/testTarget/showSocialProofPDPSelector';
import ProductViewsCountEN from 'components/ProductPage/ProductViewsCount/locales/ProductViewsCount_en_US';
import ProductViewsCountFR from 'components/ProductPage/ProductViewsCount/locales/ProductViewsCount_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(ProductViewsCountEN, ProductViewsCountFR);

const formatViewCount = viewCount => {
    if (viewCount >= 1000) {
        let formattedCount = (viewCount / 1000).toFixed(1);

        if (formattedCount.endsWith('.0')) {
            formattedCount = formattedCount.slice(0, -2);
        }

        return `${formattedCount}K`;
    }

    return viewCount.toString();
};

const setAnalytics = lookBackWindowForViews => {
    anaUtils.setNextPageData({
        linkData: `in-session:social proofing message:${lookBackWindowForViews}`
    });
};

const ProductViewsCount = ({ blackBackground, extraMargin, unlockWidth = false }) => {
    const productViews = useSelector(productViewsSelector);
    const showSessionAIMsg = useSelector(showSessionAIMsgSelector);
    const showSocialProofPDP = useSelector(showSocialProofPDPSelector);

    const { peopleViewing = 0, thresholdForViews: thresholdForViewsRaw = 0, lookBackWindowForViews } = productViews;
    const thresholdForViews = Number(thresholdForViewsRaw);
    const hasReachedThreshold = peopleViewing && thresholdForViews && peopleViewing >= thresholdForViews;

    if (hasReachedThreshold) {
        setAnalytics(lookBackWindowForViews);
    }

    if ((!showSessionAIMsg && !showSocialProofPDP) || !peopleViewing || !thresholdForViews || !hasReachedThreshold) {
        return null;
    }

    const isChallenger = showSocialProofPDP.challengerOne || showSocialProofPDP.challengerTwo;
    const isTransparentStyle = isChallenger && !blackBackground;
    const popularLabel = showSocialProofPDP.challengerOne ? getText('popular') : getText('popularNow');
    const viewsLabel = showSocialProofPDP.challengerOne ? getText('recentViews') : getText('peopleViewed');

    return (
        <Box
            marginTop={4}
            backgroundColor={colors.black}
            borderRadius={2}
            paddingLeft={2}
            paddingRight={2}
            width='fit-content'
            {...(!unlockWidth && { maxWidth: '375px' })}
            {...(isTransparentStyle && { marginTop: extraMargin ? '2px' : 0, paddingLeft: 0, backgroundColor: 'unset' })}
        >
            <Text
                is='p'
                lineHeight='24px'
                fontSize='sm'
                color={colors.white}
                {...(isTransparentStyle && { color: colors.black, lineHeight: 1, verticalAlign: 'middle' })}
            >
                <Text paddingRight={1}>🤩</Text>
                <Text {...(showSocialProofPDP.challengerOne && !showSocialProofPDP.challengerTwo && { fontWeight: 'bold' })}>
                    {popularLabel}
                </Text>{' '}
                <strong>{formatViewCount(peopleViewing)}+</strong> {viewsLabel}
            </Text>
        </Box>
    );
};

export default wrapFunctionalComponent(ProductViewsCount, 'ProductViewsCount');
